import { useAppSelector } from "src/store/hooks";
import Modal from "./Modal";
import MarkdownRenderer from "./MarkdownRenderer";
import React from "react";
import { createAndSaveEvent } from "src/services/EventLoggingService/EventLoggingService";
import { UserEvent } from "@app/common";
import { getAllEvents } from "src/services/DBService/DbService";
import SecondaryButton from "../atoms/SecondaryButton";

const OnboardingPopup = () => {
    const user = useAppSelector(state => state.globalState.user);
    const config = useAppSelector(state => state.globalState.config);

    const [isOpen, setIsOpen] = React.useState(false);

    React.useEffect(() => {
        // fetch user events to check if onboarding popup was already dismissed
        const fetchUserEvents = async () => {
            if (user) {
                const fetchedUserEvents = await getAllEvents()
                const onboardingPopupDismissedEvent = fetchedUserEvents.find((event: UserEvent) => event.type === 'onboarding_popup_dismissed');
                if (!onboardingPopupDismissedEvent) {
                    setIsOpen(true);
                }
            }
        };
        fetchUserEvents();
    }, [user]);

    const onConfirmClicked = () => {
        createAndSaveEvent(user?.code, 'onboarding_popup_dismissed', '');
        setIsOpen(false);
    };

    if (!isOpen || !config?.onboardingPopupContent) {
        return null;
    }

    return (
        <Modal>
            <div className="popup-modal">
                <div>
                    <MarkdownRenderer content={config?.onboardingPopupContent || ""} />
                </div>
                <div className="popup-modal-button-bar">
                    <SecondaryButton className="button confirm" onClick={onConfirmClicked} label="OK" />
                </div>
            </div>
        </Modal>
    );
}

export default OnboardingPopup